export const APP_LOAD = 'APP_LOAD';
export const REDIRECT = 'REDIRECT';
export const RESET = 'RESET';

export const RESET_REGISTER = 'RESET_REGISTER';

export const SET_LOGIN_PENDING = 'SET_LOGIN_PENDING';
export const SET_LOGIN_SUCCESS = 'SET_LOGIN_SUCCESS';
export const SET_LOGIN_ERROR = 'SET_LOGIN_ERROR';
export const LOGIN = 'LOGIN';

export const SET_RESET_PENDING = 'SET_RESET_PENDING';
export const SET_RESET_SUCCESS = 'SET_RESET_SUCCESS';
export const SET_RESET_CONFIRM_SUCCESS = 'SET_RESET_CONFIRM_SUCCESS';
export const SET_RESET_ERROR = 'SET_RESET_ERROR';
export const SET_RESET_CANCEL = 'SET_RESET_CANCEL';
export const SET_CLEAR_ERROR = 'SET_CLEAR_ERROR';
export const SET_VERIFY_USER_SUCCESS = 'SET_VERIFY_USER_SUCCESS';

export const SET_DISABLE_USER_SIGNIN = 'SET_DISABLE_USER_SIGNIN';

export const SET_NEW_PASSWORD_SUCCESS = 'SET_NEW_PASSWORD_SUCCESS';
export const SET_NEW_PASSWORD_ERROR = 'SET_NEW_PASSWORD_ERROR';

export const SET_NEW_COMPANY_SUCCESS = 'SET_NEW_COMPANY_SUCCESS';
export const SET_NEW_COMPANY_ERROR = 'SET_NEW_COMPANY_ERROR';

export const LOGOUT = 'LOGOUT';

export const SET_REGISTER_PENDING = 'SET_REGISTER_PENDING';
export const REGISTER = 'REGISTER';
export const REGISTER_USER_CONFIRM = 'REGISTER_USER_CONFIRM';
export const SET_REGISTER_ERROR = 'SET_REGISTER_ERROR';
export const UNAUTH_USER = 'UNAUTH_USER';

export const ASYNC_START = 'ASYNC_START';
export const ASYNC_END = 'ASYNC_END';
export const HOME_PAGE_LOADED = 'HOME_PAGE_LOADED';
export const PROFILE_PAGE_LOADED = 'PROFILE_PAGE_LOADED';

export const SET_DA_LOGIN_PENDING = 'SET_DA_LOGIN_PENDING';
export const SET_DA_LOGIN_SUCCESS = 'SET_DA_LOGIN_SUCCESS';
export const SET_DA_LOGIN_ERROR = 'SET_DA_LOGIN_ERROR';

export const SET_CUSTOMER_INFO_PENDING = 'SET_CUSTOMER_INFO_PENDING';
export const SET_CUSTOMER_INFO_SUCCESS = 'SET_CUSTOMER_INFO_SUCCESS';
export const SET_CUSTOMER_INFO_ERROR = 'SET_CUSTOMER_INFO_ERROR';

export const SET_APPLICATION_INFO_UPDATE_PENDING =
  'SET_APPLICATION_INFO_UPDATE_PENDING';
export const SET_APPLICATION_INFO_UPDATE_SUCCESS =
  'SET_APPLICATION_INFO_UPDATE_SUCCESS';
export const SET_APPLICATION_INFO_UPDATE_ERROR =
  'SET_APPLICATION_INFO_UPDATE_ERROR';

export const SET_AGENT_INFO_PENDING = 'SET_AGENT_INFO_PENDING';
export const SET_AGENT_INFO_SUCCESS = 'SET_AGENT_INFO_SUCCESS';
export const SET_AGENT_INFO_UPDATE = 'SET_AGENT_INFO_UPDATE';
export const SET_AGENT_INFO_DELETE = 'SET_AGENT_INFO_DELETE';
export const SET_AGENT_INFO_ERROR = 'SET_AGENT_INFO_ERROR';
export const SET_REMOVE_INFO_ERROR = 'SET_REMOVE_INFO_ERROR';

export const SET_AGENT_INFO_UPLOAD_PENDING = 'SET_AGENT_INFO_UPLOAD_PENDING';
export const SET_AGENT_INFO_UPLOAD_SUCCESS = 'SET_AGENT_INFO_UPLOAD_SUCCESS';
export const SET_AGENT_INFO_UPLOAD_ERROR = 'SET_AGENT_INFO_UPLOAD_ERROR';
export const SET_REMOVE_UPLOAD_ERROR = 'SET_REMOVE_UPLOAD_ERROR';
export const SET_AGENT_INFO_DELETE_SUCCESS = 'SET_AGENT_INFO_DELETE_SUCCESS';

export const SET_DELETE_UPLOAD_SUCCESS = 'SET_DELETE_UPLOAD_SUCCESS';

export const SET_CUSTOMER_SAVE_INFO_PENDING = 'SET_CUSTOMER_INFO_PENDING';
export const SET_CUSTOMER_SAVE_INFO_SUCCESS = 'SET_CUSTOMER_INFO_SUCCESS';
export const SET_CUSTOMER_SAVE_INFO_ERROR = 'SET_CUSTOMER_INFO_ERROR';

export const SET_INSURANCE_INFO_PENDING = 'SET_INSURANCE_INFO_PENDING';
export const SET_INSURANCE_INFO_SUCCESS = 'SET_INSURANCE_INFO_SUCCESS';
export const SET_INSURANCE_INFO_ERROR = 'SET_INSURANCE_INFO_ERROR';

export const SET_SEND_EMAIL_PENDING = 'SET_SEND_EMAIL_PENDING';
export const SET_SEND_EMAIL_SUCCESS = 'SET_SEND_EMAIL_SUCCESS';
export const SET_SEND_EMAIL_ERROR = 'SET_SEND_EMAIL_ERROR';

export const SET_REMOVE_ERROR = 'SET_REMOVE_ERROR';

export const SET_ERROR = 'SET_ERROR';
export const HIDE_ERROR = 'HIDE_ERROR';

export const HTTP_404_ERROR = 'HTTP_404_ERROR';
export const HTTP_500_ERROR = 'HTTP_500_ERROR';
export const HTTP_OTHER_ERROR = 'HTTP_OTHER_ERROR';
